import cn from 'classnames';
import React from 'react';
import { useNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';
import type { FC } from 'react';

import type { TCustomButton } from './models';

export const CustomButton: FC<TCustomButton> = ({
    CustomButton: CoreCustomButton,
    backgroundColor,
    block,
    children,
    className,
    contentColor,
    dataTestId,
    disabled,
    href,
    innerClassName,
    loading,
    nowrap,
    onClick,
    size,
    stateType,
    styles,
    type,
}) => {
    const {
        children: otherChildren,
        leftAddons,
        rightAddons,
    } = useNamedContainersWithChildren(children);

    const button = (
        <CoreCustomButton
            backgroundColor={backgroundColor}
            block={block}
            className={innerClassName}
            contentColor={contentColor}
            dataTestId={dataTestId}
            disabled={disabled}
            href={href}
            leftAddons={leftAddons}
            loading={loading}
            nowrap={nowrap}
            onClick={onClick}
            rightAddons={rightAddons}
            size={size}
            stateType={stateType}
            type={type}
        >
            {/* Проверка необходима для поддержки iconOnly режима. useNamedContainersWithChildren трансформирует children в массив, а iconOnly режим активируется если значение children falsy */}
            {otherChildren.length > 0 && otherChildren}
        </CoreCustomButton>
    );

    return className ? (
        <div className={cn({ [styles.container]: !block }, className)}>{button}</div>
    ) : (
        button
    );
};
